/* Pu$$y Lemonade — Theme JS */

// Sticky header shadow on scroll
(function () {
  const header = document.getElementById('site-header');
  if (!header) return;
  const observer = new IntersectionObserver(
    ([e]) => header.classList.toggle('scrolled', !e.isIntersecting),
    { rootMargin: '-1px 0px 0px 0px', threshold: [1] }
  );
  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'height:1px;pointer-events:none;';
  document.body.prepend(sentinel);
  observer.observe(sentinel);
})();

// Accordion — passive listeners for iOS scroll perf
document.querySelectorAll('.accordion__trigger').forEach((btn) => {
  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    const body = btn.nextElementSibling;
    if (body) body.classList.toggle('open', !expanded);
  }, { passive: true });
});

// Quantity stepper — new .qty-wrap selector + old .quantity-wrapper
function bindQty(wrapper) {
  const input = wrapper.querySelector('.qty-input');
  if (!input) return;
  wrapper.querySelector('.qty-minus')?.addEventListener('click', () => {
    if (Number(input.value) > 1) input.value = Number(input.value) - 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, { passive: true });
  wrapper.querySelector('.qty-plus')?.addEventListener('click', () => {
    input.value = Number(input.value) + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, { passive: true });
}
document.querySelectorAll('.qty-wrap, .quantity-wrapper').forEach(bindQty);

// Pack size selector — toggle active + update form variant
document.querySelectorAll('.size-btn').forEach((btn) => {
  btn.addEventListener('click', () => {
    btn.closest('.size-options')?.querySelectorAll('.size-btn').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');
    const vid = btn.dataset.variantId;
    if (vid) {
      const el = document.getElementById('selected-variant-id');
      if (el) el.value = vid;
    }
  }, { passive: true });
});

// Qty stepper → keep form hidden qty in sync
document.querySelectorAll('.qty-input').forEach((input) => {
  input.addEventListener('change', () => {
    const formQty = document.getElementById('form-qty');
    if (formQty) formQty.value = input.value;
  }, { passive: true });
});

// Shared cart helper — avoids cross-domain redirect from native form POST
async function ajaxAddToCart(vid, qty) {
  try {
    const res = await fetch('/cart/add.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(vid), quantity: qty }),
    });
    return res.ok;
  } catch (_) { return false; }
}

// Add to Cart — AJAX to keep session on same domain, then go to cart
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const vid = document.getElementById('selected-variant-id')?.value || '48284769550584';
    const qty = parseInt(document.getElementById('form-qty')?.value || '1', 10);
    const btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    await ajaxAddToCart(vid, qty);
    window.location.href = '/cart';
  });
})();

// Buy It Now — AJAX then straight to checkout
(function () {
  const btn = document.getElementById('buy-now-btn');
  if (!btn) return;
  btn.addEventListener('click', async () => {
    const vid = document.getElementById('selected-variant-id')?.value || '48284769550584';
    const qty = parseInt(document.getElementById('form-qty')?.value || '1', 10);
    btn.textContent = 'Loading…';
    btn.disabled = true;
    await ajaxAddToCart(vid, qty);
    window.location.href = '/checkout';
  });
})();

// Subscribe / one-time purchase toggle
document.querySelectorAll('.purchase-option').forEach((opt) => {
  opt.addEventListener('click', () => {
    opt.closest('.purchase-options')?.querySelectorAll('.purchase-option').forEach((o) => o.classList.remove('active'));
    opt.classList.add('active');
  }, { passive: true });
});

// Gallery thumbnail swap
document.querySelectorAll('.product-gallery__thumb').forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const img   = thumb.querySelector('img');
    const main  = (thumb.closest('.product-gallery') || document).querySelector('#gallery-main, .product-gallery__main img');
    if (img && main) main.src = img.src;
    thumb.closest('.product-gallery__thumbs, .product-gallery')
      ?.querySelectorAll('.product-gallery__thumb')
      .forEach((t) => t.classList.remove('active'));
    thumb.classList.add('active');
  }, { passive: true });
});

// Variant selector (legacy)
document.querySelectorAll('.variant-option').forEach((opt) => {
  opt.addEventListener('click', () => {
    opt.closest('.variant-options')?.querySelectorAll('.variant-option').forEach((o) => o.classList.remove('selected'));
    opt.classList.add('selected');
  }, { passive: true });
});

// iOS: prevent scroll when touching inside horizontal scroll containers
document.querySelectorAll('.comparison-table-wrap').forEach((el) => {
  let startX, startY;
  el.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });
  el.addEventListener('touchmove', (e) => {
    const dx = Math.abs(e.touches[0].clientX - startX);
    const dy = Math.abs(e.touches[0].clientY - startY);
    if (dx > dy) e.stopPropagation();
  }, { passive: true });
});
